import { FeatureValues } from './feature-flags.model'

export const isTruthyString = (v: string): boolean => {
  const s = v.trim().toLowerCase()
  return s.length > 0 && s !== 'false' && s !== '0' && s !== 'off' && s !== 'no'
}

export const toBoolean = (v?: FeatureValues): boolean => {
  if (typeof v === 'boolean') return v
  if (typeof v === 'string' && v) return isTruthyString(v)

  return Boolean(v)
}

export const toStringOrNull = (v: FeatureValues): string | null => {
  return typeof v === 'string' ? v : null
}
